"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

function Grid(props) {
  var _a, _b;

  return react_1.default.createElement("svg", __assign({
    fill: "#fff",
    viewBox: "0 0 105 105"
  }, __assign(__assign({}, props), {
    width: (_a = props.width) !== null && _a !== void 0 ? _a : 105,
    height: (_b = props.height) !== null && _b !== void 0 ? _b : 105,
    className: "icon-loading" + (props.className ? " " + props.className : '')
  })), react_1.default.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5
  }, react_1.default.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "0s",
    dur: "1s",
    values: "1;.2;1",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), react_1.default.createElement("circle", {
    cx: 12.5,
    cy: 52.5,
    r: 12.5,
    fillOpacity: 0.5
  }, react_1.default.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "100ms",
    dur: "1s",
    values: "1;.2;1",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), react_1.default.createElement("circle", {
    cx: 52.5,
    cy: 12.5,
    r: 12.5
  }, react_1.default.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "300ms",
    dur: "1s",
    values: "1;.2;1",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), react_1.default.createElement("circle", {
    cx: 52.5,
    cy: 52.5,
    r: 12.5
  }, react_1.default.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "600ms",
    dur: "1s",
    values: "1;.2;1",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), react_1.default.createElement("circle", {
    cx: 92.5,
    cy: 12.5,
    r: 12.5
  }, react_1.default.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "800ms",
    dur: "1s",
    values: "1;.2;1",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), react_1.default.createElement("circle", {
    cx: 92.5,
    cy: 52.5,
    r: 12.5
  }, react_1.default.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "400ms",
    dur: "1s",
    values: "1;.2;1",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), react_1.default.createElement("circle", {
    cx: 12.5,
    cy: 92.5,
    r: 12.5
  }, react_1.default.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "700ms",
    dur: "1s",
    values: "1;.2;1",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), react_1.default.createElement("circle", {
    cx: 52.5,
    cy: 92.5,
    r: 12.5
  }, react_1.default.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "500ms",
    dur: "1s",
    values: "1;.2;1",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), react_1.default.createElement("circle", {
    cx: 92.5,
    cy: 92.5,
    r: 12.5
  }, react_1.default.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "200ms",
    dur: "1s",
    values: "1;.2;1",
    calcMode: "linear",
    repeatCount: "indefinite"
  })));
}

exports.default = Grid;